import React from 'react'

/** UK — Union Jack (simplified, no clip-path; reads clearly at ~28px wide) */
function FlagUk({ className }) {
  return (
    <svg className={className} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFF" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="3.5" />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  )
}

/**
 * Greece — 9 horizontal stripes (blue–white alternating, blue at top),
 * square hoist canton (5 stripes tall) with white Orthodox cross.
 * Ratio 3∶2 (matches common SVG representations).
 */
function FlagGr({ className }) {
  const blue = '#005BAE'
  const white = '#FFFFFF'
  const W = 27
  const H = 18
  const stripes = 9
  const sh = H / stripes
  const canton = 5 * sh
  const crossArm = canton / 6
  const crossCenter = canton / 2

  return (
    <svg className={className} viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Stripes to the right of the canton (top five bands only) */}
      <rect x={canton} y={0} width={W - canton} height={sh} fill={blue} />
      <rect x={canton} y={sh} width={W - canton} height={sh} fill={white} />
      <rect x={canton} y={2 * sh} width={W - canton} height={sh} fill={blue} />
      <rect x={canton} y={3 * sh} width={W - canton} height={sh} fill={white} />
      <rect x={canton} y={4 * sh} width={W - canton} height={sh} fill={blue} />
      {/* Full-width stripes (bottom four bands) */}
      <rect x={0} y={5 * sh} width={W} height={sh} fill={white} />
      <rect x={0} y={6 * sh} width={W} height={sh} fill={blue} />
      <rect x={0} y={7 * sh} width={W} height={sh} fill={white} />
      <rect x={0} y={8 * sh} width={W} height={sh} fill={blue} />
      {/* Canton: blue field + white Greek cross */}
      <rect x={0} y={0} width={canton} height={canton} fill={blue} />
      <rect x={crossCenter - crossArm / 2} y={0} width={crossArm} height={canton} fill={white} />
      <rect x={0} y={crossCenter - crossArm / 2} width={canton} height={crossArm} fill={white} />
    </svg>
  )
}

/** Netherlands */
function FlagNl({ className }) {
  return (
    <svg className={className} viewBox="0 0 6 4" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="6" height="1.33" fill="#AE1C28" />
      <rect y="1.33" width="6" height="1.34" fill="#FFF" />
      <rect y="2.67" width="6" height="1.33" fill="#21468B" />
    </svg>
  )
}

/**
 * SVG flags for EN / EL / NL (renders on Windows; not dependent on emoji fonts).
 */
export function LanguageFlag({ code, className }) {
  switch (code) {
    case 'en':
      return <FlagUk className={className} />
    case 'el':
      return <FlagGr className={className} />
    case 'nl':
      return <FlagNl className={className} />
    default:
      return <FlagUk className={className} />
  }
}
